export const SOCIAL_MEDIA = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  GOOGLE_PLUS: 'googlePlus',
  LINKEDIN: 'linkedIn'
};
